module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_start_guanghuan.e88f6.png";